import { render } from "./empty-stories.vue?vue&type=template&id=485827e8"
import script from "./empty-stories.vue?vue&type=script&lang=js"
export * from "./empty-stories.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__